import { buildModelManager } from "../builder.js";
const DefaultShopifyCheckoutSelection = {
  __typename: true,
  id: true,
  abandonedCheckoutUrl: true,
  appliedDiscount: true,
  buyerAcceptsMarketing: true,
  completedAt: true,
  createdAt: true,
  creditCard: true,
  currency: true,
  customerId: true,
  customerLocale: true,
  device: true,
  discountCode: true,
  email: true,
  legalNoticeUrl: true,
  locationId: true,
  name: true,
  note: true,
  noteAttributes: true,
  orderId: true,
  orderStatusUrl: true,
  paymentDue: true,
  paymentUrl: true,
  payments: true,
  phone: true,
  presentmentCurrency: true,
  privacyPolicyUrl: true,
  refundPolicyUrl: true,
  requiresShipping: true,
  reservationTime: true,
  reservationTimeLeft: true,
  shippingAddressId: true,
  shippingLine: true,
  shippingPolicyUrl: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyPaymentsAccountId: true,
  shopifyUpdatedAt: true,
  sourceIdentifier: true,
  sourceName: true,
  sourceUrl: true,
  subscriptionPolicyUrl: true,
  subtotalPrice: true,
  taxExempt: true,
  taxLines: true,
  taxManipulations: true,
  taxesIncluded: true,
  termsOfSaleUrl: true,
  termsOfServiceUrl: true,
  token: true,
  totalLineItemsPrice: true,
  totalPrice: true,
  totalTax: true,
  totalTipReceived: true,
  updatedAt: true,
  userId: true,
  webUrl: true
};
const modelApiIdentifier = "shopifyCheckout";
const pluralModelApiIdentifier = "shopifyCheckouts";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyCheckoutSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "deleteShopifyCheckout",
    operationReturnType: "DeleteShopifyCheckout",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShopifyCheckouts",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyCheckoutGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...["create", "bulkCreate", "update", "bulkUpdate"].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyCheckout does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyCheckoutManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyCheckoutSelection,
  operations
);
export {
  DefaultShopifyCheckoutSelection,
  ShopifyCheckoutManager
};
//# sourceMappingURL=ShopifyCheckout.js.map
